import moment from "moment";

const defaultState = () => {
	return {
		downloads: {
			count: 0,
			results: [],
		},
	};
};

const state = {
	downloads: defaultState().downloads,
};

const getters = {
	downloads: (state) => {
		return {
			count: state.downloads.count,
			results: state.downloads.results.map((item, item_i) => {
				let name = !item.folder_path
					? item.files[0].name
					: item.files.length
					? item.files[item.files.length - 1].name
					: item.folder_path;

				let date = name.split("_")[0].split("-");

				let link = !item.folder_path
					? item.files[0].link
					: item.files.length
					? item.files[item.files.length - 1].link
					: null;

				let files = !item.folder_path ? [] : item.files;
				files.pop();

				let parameters = item.parameters;

				if (Array.isArray(parameters)) {
					let newParameters = {};

					parameters.forEach((pitem) => {
						if (newParameters[pitem.name])
							newParameters[pitem.name].push(pitem.value);
						else newParameters[pitem.name] = [pitem.value];
					});

					parameters = newParameters;
				}

				return {
					id: item_i,
					downloadId: item.id,
					date: moment(`${date[2]}-${date[0]}-${date[1]}`).format(
						"MMM D, YYYY"
					),
					name: name,
					link: link,
					files: files,
					parameters: parameters,
					hasChildren: !item.folder_path ? false : true,
					is_pending: item.is_pending,
					is_failed: item.is_failed,
					note: item.note,
				};
			}),
		};
	},
};

const actions = {};

const mutations = {
	GET_DOWNLOADS: (state, payload) => {
		if (payload) {
			state.downloads.count += payload.count;
			state.downloads.results = payload.results;
		} else {
			state.downloads = defaultState().downloads;
		}
	},
};

export default {
	namespaced: false,
	state,
	getters,
	actions,
	mutations,
};
